import { ReactNode } from "react";
import { useHasAnyRole } from "./useCurrentUser";

interface RequiresRoleProps {
  /** Render children only when the user holds AT LEAST ONE of these roles. */
  roles: string[];
  /** Optional fallback rendered when the user lacks any of the roles. */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Client-side role guard. Hides the wrapped UI until the user's DM_USER_ROLE
 * payload arrives and shows it only when they hold one of the requested roles.
 * Pair with server-side enforcement — this is render-gating, not security.
 *
 * Example:
 *   <RequiresRole roles={["DM_ADMIN", "DM_IT_ADMIN"]}>
 *     <Link to="/dm/admin">Admin</Link>
 *   </RequiresRole>
 */
const RequiresRole = ({ roles, fallback = null, children }: RequiresRoleProps) => {
  const allowed = useHasAnyRole(roles);
  return <>{allowed ? children : fallback}</>;
};

export default RequiresRole;
